import { render, staticRenderFns } from "./VerifyEmailLender-Mobile.vue?vue&type=template&id=81a922b0&scoped=true"
import script from "./VerifyEmailLender-Mobile.vue?vue&type=script&lang=js"
export * from "./VerifyEmailLender-Mobile.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailLender-Mobile.vue?vue&type=style&index=0&id=81a922b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a922b0",
  null
  
)

export default component.exports